import React, { useEffect, useState } from "react";
import { Input, Select, DatePicker, TimePicker, Button, Spin, message } from "antd";
import TextArea from "antd/es/input/TextArea";
import moment from "moment";
import Axios from "../../../services/AxiosInterceptor";
import { useParams, useNavigate } from "react-router-dom";

const { Option } = Select;

const EditDemo = () => {
  const { id } = useParams();
  const navigate = useNavigate();
  
  const [loading, setLoading] = useState(true);
  const [locationandRec, setLocationandRec] = useState([]);
  const [locationIndex, setLocationIndex] = useState(0);
  const [preview, setPreview] = useState(null);
  const [imageFile, setImageFile] = useState(null);

  const [formData, setFormData] = useState({
    title: "",
    classMode: "",
    sessionType: "",
    seatAvailability: "",
    benefits: ["", "", "", "", ""],
    description: "",
  });

  const [locationSpecificData, setLocationSpecificData] = useState({});
  const weekDays = ["Sunday", "Monday", "Tuesday", "Wednesday", "Thursday", "Friday", "Saturday"];

  // Fetch demo data by ID
  useEffect(() => {
    const fetchDemoData = async () => {
      try {
        setLoading(true);
        const response = await Axios.post("/api/single-demo", { id: { id } });
        
        if (response.data.success) {
          const demo = response.data.data;
          
          // Set form data
          setFormData({
            title: demo.title || "",
            classMode: demo.classMode || "",
            sessionType: demo.sessionType || "",
            seatAvailability: demo.seatAvailability || "",
            benefits: demo.benefits || ["", "", "", "", ""],
            description: demo.description || "",
          });

          // Set image preview if exists
          if (demo.image) {
            setPreview(`https://yogamatic.in/api/upload/${demo.image}`);
          }

          // Set location specific data
          const locData = {};
          demo.locations?.forEach((loc) => {
            locData[loc.name] = {
              resources: loc.resources || [],
              sessions: loc.sessions || [],
            };
          });
          setLocationSpecificData(locData);
        }
      } catch (error) {
        console.error("Error fetching demo:", error);
        message.error("Failed to load demo data");
      } finally {
        setLoading(false);
      }
    };

    fetchDemoData();
  }, [id]);

  const getLocationandresource = async () => {
    try {
      const response = await Axios.get("api/location-list");
      const result = response.data;
      if (result) {
        setLocationandRec(result);
      }
    } catch (error) {
      console.error("Error loading location & resource:", error);
    }
  };

  useEffect(() => {
    getLocationandresource();
  }, []);

  const handleCommonField = (key, value) => {
    setFormData((prev) => ({
      ...prev,
      [key]: value,
    }));
  };

  const handleLocationField = (key, value) => {
    const currentLocation = locationandRec[locationIndex]?.location;
    setLocationSpecificData((prev) => ({
      ...prev,
      [currentLocation]: {
        ...prev[currentLocation],
        [key]: value,
      },
    }));
  };

  const handleImageChange = (event) => {
    const file = event.target.files[0];
    if (file) {
      setImageFile(file);
      const imageUrl = URL.createObjectURL(file);
      setPreview(imageUrl);
    }
  };

  const handleBenefitsChange = (index, value) => {
    const updatedBenefits = [...formData.benefits];
    updatedBenefits[index] = value;
    setFormData((prev) => ({
      ...prev,
      benefits: updatedBenefits,
    }));
  };

  const handleSubmitSessions = async () => {
    const currentLocation = locationandRec[locationIndex]?.location;
    const sessionData = locationSpecificData[currentLocation] || {};

    try {
      const response = await Axios.post(
        "api/session-creation",
        {
          startDate: sessionData.startDate,
          endDate: sessionData.endDate,
          sessionDuration: sessionData.sessionDuration,
          startTime: sessionData.startTime,
          endTime: sessionData.endTime,
          offDays: sessionData.offDays,
          bufferTime: sessionData.bufferTime,
        },
        {
          headers: {
            "Content-Type": "application/json",
          },
        }
      );

      const result = response.data;

      if (result?.success) {
        setLocationSpecificData((prev) => ({
          ...prev,
          [currentLocation]: {
            ...prev[currentLocation],
            sessions: result.sessionData.sessions,
          },
        }));
        message.success("Sessions created successfully!");
      }
    } catch (error) {
      console.error("❌ Error:", error);
      message.error("Failed to create sessions");
    }
  };

  const handlelocaationIndex = (index) => {
    setLocationIndex(index);
  };

  const handlecheck = (resource) => {
    const currentLocation = locationandRec[locationIndex].location;
    setLocationSpecificData((prev) => {
      const locationData = prev[currentLocation] || {};
      const resources = locationData.resources || [];
      let updatedResources;

      if (resources.includes(resource)) {
        updatedResources = resources.filter((res) => res !== resource);
      } else {
        updatedResources = [...resources, resource];
      }

      return {
        ...prev,
        [currentLocation]: {
          ...locationData,
          resources: updatedResources,
        },
      };
    });
  };

  const handleSubmit = async () => {
    try {
      const locations = Object.keys(locationSpecificData).map((loc) => ({
        name: loc,
        resources: locationSpecificData[loc].resources || [],
        sessions: locationSpecificData[loc].sessions || [],
      }));

      const submitData = {
        title: formData.title,
        classMode: formData.classMode,
        sessionType: formData.sessionType,
        seatAvailability: parseInt(formData.seatAvailability),
        benefits: formData.benefits.filter((b) => b.trim() !== ""),
        description: formData.description,
        locations,
      };

      const formDataToSend = new FormData();
      formDataToSend.append("demoId", id);
      formDataToSend.append("services[0][title]", submitData.title);
      formDataToSend.append("services[0][classMode]", submitData.classMode);
      formDataToSend.append("services[0][sessionType]", submitData.sessionType);
      formDataToSend.append("services[0][seatAvailability]", submitData.seatAvailability);

      submitData.benefits.forEach((benefit, index) => {
        formDataToSend.append(`services[0][benefits][${index}]`, benefit);
      });

      formDataToSend.append("services[0][description]", submitData.description);

      if (imageFile) {
        formDataToSend.append("image", imageFile);
      }

      submitData.locations.forEach((loc, index) => {
        formDataToSend.append(`services[0][locations][${index}][name]`, loc.name);

        loc.resources.forEach((resource, rIndex) => {
          formDataToSend.append(`services[0][locations][${index}][resources][${rIndex}]`, resource);
        });

        loc.sessions.forEach((session, sessionIndex) => {
          formDataToSend.append(
            `services[0][locations][${index}][sessions][${sessionIndex}][date]`,
            session.date
          );

          session.timeSlots.forEach((timeSlot, timeIndex) => {
            formDataToSend.append(
              `services[0][locations][${index}][sessions][${sessionIndex}][timeSlots][${timeIndex}][time]`,
              timeSlot.time || timeSlot
            );
          });
        });
      });

      const response = await Axios.post("/api/update-demo", formDataToSend, {
        headers: {
          "Content-Type": "multipart/form-data",
        },
      });

      const result = response.data;

      if (result?.success) {
        message.success("Demo updated successfully!");
        setTimeout(() => {
          navigate("/demo_list");
        }, 1500);
      } else {
        console.error("Server response:", result);
        message.error("Failed to update demo: " + (result.message || "Unknown error"));
      }
    } catch (error) {
      console.error("Error:", error);
      message.error("An error occurred while updating the demo.");
    }
  };

  const currentLocation = locationandRec[locationIndex]?.location;
  const currentLocationData = locationSpecificData[currentLocation] || {};

  if (loading) {
    return (
      <div className="flex items-center justify-center h-screen">
        <Spin size="large" />
      </div>
    );
  }

  return (
    <div className="container p-4 mx-auto md:p-6">
      <h3 className="mb-6 text-2xl font-semibold text-gray-800">Edit Demo</h3>

      {/* Image Upload Section */}
      <div className="flex flex-col items-center p-4 mb-6 border-2 border-orange-400 rounded-lg shadow-sm md:flex-row md:p-6">
        <div className="w-full mb-4 md:w-1/2 md:mb-0 md:pr-4">
          <label className="block mb-2 font-medium text-gray-700">Demo Image</label>
          <Input 
            type="file" 
            onChange={handleImageChange} 
            className="w-full" 
            accept="image/*" 
          />
        </div>
        <div className="flex flex-col items-center w-full md:w-1/2">
          <p className="mb-2 font-medium text-gray-700">Preview:</p>
          {preview && (
            <img 
              src={preview} 
              alt="Preview" 
              className="object-cover w-full max-w-sm border rounded-lg shadow-md h-60" 
            />
          )}
        </div>
      </div>

      {/* Basic Info Section */}
      <div className="grid grid-cols-1 gap-4 p-4 mb-6 border-2 border-orange-400 rounded-lg shadow-sm md:grid-cols-2 lg:grid-cols-4 md:p-6">
        <div>
          <label className="block mb-2 font-medium text-gray-700">Title</label>
          <Input
            placeholder="Demo Title"
            value={formData.title}
            onChange={(e) => handleCommonField("title", e.target.value)}
            className="w-full"
          />
        </div>
        <div>
          <label className="block mb-2 font-medium text-gray-700">Class Mode</label>
          <Select
            value={formData.classMode || undefined}
            placeholder="Choose Class Mode"
            onChange={(value) => handleCommonField("classMode", value)}
            className="w-full"
          >
            <Option value="Online">Online</Option>
            <Option value="Offline">Offline</Option>
          </Select>
        </div>
        <div>
          <label className="block mb-2 font-medium text-gray-700">Session Type</label>
          <Select
            value={formData.sessionType || undefined}
            placeholder="Select Session Type"
            onChange={(value) => handleCommonField("sessionType", value)}
            className="w-full"
          >
            <Option value="Group Session">Group Session</Option>
            <Option value="Personal Session">Personal Session</Option>
          </Select>
        </div>
        <div>
          <label className="block mb-2 font-medium text-gray-700">Seat Availability</label>
          <Input
            type="number"
            placeholder="Seats Available"
            value={formData.seatAvailability}
            onChange={(e) => handleCommonField("seatAvailability", e.target.value)}
            className="w-full"
          />
        </div>
      </div>

      {/* Benefits & Description Section */}
      <div className="p-4 mb-6 border-2 border-orange-400 rounded-lg shadow-sm md:p-6">
        <label className="block mb-3 font-medium text-gray-700">Benefits</label>
        <div className="grid grid-cols-1 gap-3 mb-4 md:grid-cols-2 lg:grid-cols-5">
          {formData.benefits.map((benefit, index) => (
            <Input
              key={index}
              placeholder={`Benefit ${index + 1}`}
              value={benefit}
              onChange={(e) => handleBenefitsChange(index, e.target.value)}
              className="w-full"
            />
          ))}
        </div>
        <div>
          <label className="block mb-2 font-medium text-gray-700">Demo Description</label>
          <TextArea
            rows={4}
            value={formData.description}
            onChange={(e) => handleCommonField("description", e.target.value)}
            className="w-full"
            placeholder="Enter demo description..."
          />
        </div>
      </div>

      {/* Location & Resource Section */}
      <div className="p-4 mb-6 border-2 border-orange-400 rounded-lg shadow-sm md:p-6">
        <label className="block mb-3 font-medium text-gray-700">Location & Resource</label>
        <div className="flex flex-wrap gap-2 mb-4">
          {locationandRec.map((item, index) => (
            <Button
              key={index}
              onClick={() => handlelocaationIndex(index)}
              type={locationIndex === index ? "primary" : "default"}
              className={locationIndex === index ? "bg-orange-500" : ""}
            >
              {item.location}
            </Button>
          ))}
        </div>

        <div className="flex flex-wrap gap-3">
          {locationandRec && locationandRec.length > 0 ? (
            locationandRec[locationIndex].resource.map((res, index) => (
              <label key={index} className="flex items-center gap-2 cursor-pointer">
                <input
                  type="checkbox"
                  checked={(currentLocationData.resources || []).includes(res)}
                  onChange={() => handlecheck(res)}
                  className="w-4 h-4"
                />
                <span className="text-gray-700">{res}</span>
              </label>
            ))
          ) : (
            <p className="text-gray-500">No resources available</p>
          )}
        </div>
      </div>

      {/* Sessions Section */}
      <div className="p-4 mb-6 border-2 border-orange-400 rounded-lg shadow-sm md:p-6">
        <label className="block mb-3 text-lg font-medium text-gray-800">
          Sessions for {currentLocation}
        </label>
        <div className="grid grid-cols-1 gap-4 mb-4 md:grid-cols-2 lg:grid-cols-3 xl:grid-cols-4">
          <div>
            <label className="block mb-2 font-medium text-gray-700">Start Date</label>
            <DatePicker
              className="w-full"
              placeholder="Start Date"
              value={currentLocationData.startDate ? moment(currentLocationData.startDate) : null}
              onChange={(date, dateString) => handleLocationField("startDate", dateString)}
            />
          </div>
          <div>
            <label className="block mb-2 font-medium text-gray-700">End Date</label>
            <DatePicker
              className="w-full"
              placeholder="End Date"
              value={currentLocationData.endDate ? moment(currentLocationData.endDate) : null}
              onChange={(date, dateString) => handleLocationField("endDate", dateString)}
            />
          </div>
          <div>
            <label className="block mb-2 font-medium text-gray-700">Session Duration (hrs)</label>
            <Input
              className="w-full"
              placeholder="Duration"
              value={currentLocationData.sessionDuration}
              onChange={(e) => handleLocationField("sessionDuration", e.target.value)}
            />
          </div>
          <div>
            <label className="block mb-2 font-medium text-gray-700">Buffer Time (mins)</label>
            <Input
              className="w-full"
              placeholder="Buffer Time"
              value={currentLocationData.bufferTime}
              onChange={(e) => handleLocationField("bufferTime", e.target.value)}
            />
          </div>
          <div>
            <label className="block mb-2 font-medium text-gray-700">Start Time</label>
            <TimePicker
              className="w-full"
              placeholder="Start Time"
              format="HH:mm"
              value={currentLocationData.startTime ? moment(currentLocationData.startTime, "HH:mm") : null}
              onChange={(time, timeString) => handleLocationField("startTime", timeString)}
            />
          </div>
          <div>
            <label className="block mb-2 font-medium text-gray-700">End Time</label>
            <TimePicker
              className="w-full"
              placeholder="End Time"
              format="HH:mm"
              value={currentLocationData.endTime ? moment(currentLocationData.endTime, "HH:mm") : null}
              onChange={(time, timeString) => handleLocationField("endTime", timeString)}
            />
          </div>
          <div className="md:col-span-2">
            <label className="block mb-2 font-medium text-gray-700">Off Days</label>
            <Select
              mode="multiple"
              placeholder="Select Off Days"
              value={currentLocationData.offDays || []}
              onChange={(value) => handleLocationField("offDays", value)}
              className="w-full"
            >
              {weekDays.map((day) => (
                <Option key={day} value={day}>
                  {day}
                </Option>
              ))}
            </Select>
          </div>
        </div>
        <Button 
          onClick={handleSubmitSessions}
          type="primary"
          className="bg-orange-500"
        >
          Save Sessions
        </Button>
      </div>

      {/* Sessions Display */}
      <div className="p-4 mb-6 border-2 border-orange-400 rounded-lg shadow-sm md:p-6">
        <div className="overflow-x-auto">
          <div className="grid grid-cols-2 gap-2 mb-2 font-semibold text-gray-700">
            <div>Session Dates</div>
            <div>Times</div>
          </div>
          <hr className="mb-4" />
          {currentLocationData.sessions?.map((session, sessionIndex) =>
            session.timeSlots?.map((timeSlot, timeIndex) => (
              <div className="grid grid-cols-2 gap-2 mb-2" key={`${sessionIndex}-${timeIndex}`}>
                <div>
                  {timeIndex === 0 && (
                    <span className="inline-block px-3 py-1 text-sm bg-gray-100 rounded">
                      {session?.date}
                    </span>
                  )}
                </div>
                <div>
                  <span className="inline-block px-3 py-1 text-sm bg-blue-100 rounded">
                    {timeSlot.time || timeSlot}
                  </span>
                </div>
              </div>
            ))
          )}
          {(!currentLocationData.sessions || currentLocationData.sessions.length === 0) && (
            <p className="text-gray-500">No sessions created yet</p>
          )}
        </div>
      </div>

      {/* Submit Section */}
      <div className="flex justify-end gap-3">
        <Button onClick={() => navigate("/demo-list")} size="large">
          Cancel
        </Button>
        <Button 
          onClick={handleSubmit} 
          type="primary" 
          size="large"
          className="bg-orange-500"
        >
          Update Demo
        </Button>
      </div>
    </div>
  );
};

export default EditDemo;
